<template>
  <div class="menu">
    <scroller :offset="20">
      <button-menu
        :label="dictionnary ? dictionnary.defaultMenu.format : ''"
        iconClass="sprite-formats"
        @click.native="changeMenu('FormatMenu')"
        v-if="!getRestrictedSize"
      />
      <button-menu
        :label="dictionnary ? dictionnary.defaultMenu.images : ''"
        iconClass="sprite-images"
        @click.native="$emit('openImage')"
      />
      <button-menu
        :label="dictionnary ? dictionnary.defaultMenu.emoji : ''"
        iconClass="sprite-emoji"
        @click.native="$emit('openEmoji')"
      />
      <button-menu
        :isNew="true"
        :label="dictionnary ? dictionnary.defaultMenu.templates : ''"
        iconClass="sprite-templates"
        @click.native="templateHandler"
      />
      <button-menu
        :class="{disabled: !hasElement}"
        :label="dictionnary ? dictionnary.defaultMenu.calques : ''"
        iconClass="sprite-layers"
        @click.native="changeMenu('CalquesMenu')"
      />
      <span class="separator"/>
      <button-menu
        :class="{disabled: !isImage}"
        :label="dictionnary ? dictionnary.defaultMenu.filtres : ''"
        iconClass="sprite-filter"
        @click.native="changeMenu('FiltresMenu')"
      />
      <button-menu
        :class="{disabled: !hasElement}"
        :label="dictionnary ? dictionnary.defaultMenu.ajustements : ''"
        iconClass="sprite-adjust"
        @click.native="changeMenu('AjustementsMenu')"
      />
      <span class="separator"/>
      <button-menu
        :label="dictionnary ? dictionnary.defaultMenu.texte : ''"
        iconClass="sprite-text"
        @click.native="textHandler"
      />
      <button-menu
        :label="dictionnary ? dictionnary.defaultMenu.formes :''"
        iconClass="sprite-shape"
        @click.native="changeMenu('FormesMenu')"
      />
      <image-modal :open="imageModalOpen" @close="imageModalOpen = false" :editor="editor"/>
      <template-modal
        :open="templateModalOpen"
        @close="templateModalOpen = false"
        @go="goTemplateHandler"
      />
    </scroller>
  </div>
</template>
<script>
import ButtonMenu from '@/components/buttons/ButtonMenu'
import ImageModal from '@/components/modal/ImageModal'
import TemplateModal from '@/components/modal/TemplateModal'
import Scroller from '@/components/scroller/Scroller'
import { mapGetters } from 'vuex'
import { not, empty } from 'junctions-fp'
import menu from './menu-default'
export default {
  name: 'DefaultMenu',
  mixins: [menu],
  components: {
    ButtonMenu,
    ImageModal,
    TemplateModal,
    Scroller
  },
  beforeCreate() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      imageModalOpen: false,
      templateModalOpen: false
    }
  },
  props: {},
  computed: {
    ...mapGetters(['getFontFormat', 'getCurrentColor', 'templatesList', 'getRestrictedSize']),
    hasTemplates() {
      return not(empty(this.templatesList))
    }
  },
  methods: {
    textHandler() {
      this.changeMenu('TextMenu')
    },
    templateHandler() {
      if (this.hasTemplates) {
        this.changeMenu('TemplatesMenu')
        return
      }
      this.templateModalOpen = true
    },
    goTemplateHandler() {
      this.templateModalOpen = false
      this.changeMenu('TemplatesMenu')
    }
  },
  watch: {}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/menu/DefaultMenu.vue